import { render, staticRenderFns } from "./ModalNetworkError.vue?vue&type=template&id=79d51e26"
import script from "./ModalNetworkError.js?vue&type=script&lang=js&external"
export * from "./ModalNetworkError.js?vue&type=script&lang=js&external"
import style0 from "./ModalNetworkError.vue?vue&type=style&index=0&id=79d51e26&prod&lang=scss&scopedSlots=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports